import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';

import CloseButton from './CloseButton';

const ESCAPE_KEY = 27;
const TRANSITION_DURATION = 150;

const FloatingLayer = (props) => {
	const [ on, setOn ] = useState(false);
	const [ visible, setVisible ] = useState(false);
	
	const enable_close = props?.enable_close ?? true;
	const is_public = props?.public ?? false;

	useEffect(() => {
		document.addEventListener("keydown", handleKeyDown);

		setTimeout(() => {
			setOn(true);
			setVisible(true);
		}, 0);

		return () => {
			document.removeEventListener("keydown", handleKeyDown);
		};
	}, []);

	const handleKeyDown = (e) => {
		switch(e.keyCode) {
			case ESCAPE_KEY:
				close(e, true);
				break;

			default:
				break;
		}
	};

	const close = (e, forced) => {
		if(forced == undefined) forced = false;

		if((!forced && e.target != e.currentTarget) || !enable_close) return;

		setVisible(false);

		setTimeout(() => {
			props.backButton();
		}, TRANSITION_DURATION);
	};

	let classname = props?.classname ?? 'gui_floating_layer';
	let classes = classname.split(' ');
	
	let disabled = props?.disabled ?? false;
	if(disabled) classes.push('disabledItem');

	if(props._class) {
		for(var i in props._class) {
			if(i == 'size') {
				// sizes: "small" || "normal" (blank) || "fullscreen" || "whole" || "auto" || "full"
				classes.push(`${props._class[i]}_w`);
			} else {
				classes.push(props._class[i]);
			}
		}
	}

	if(!is_public) classes.push('not_awesome');

	classname = classes.join(' ');

	let element = document.getElementById('gui_modal_root');
	if(element == null) {
		element = document.createElement('div');
		element.id = 'gui_modal_root';
		document.body.appendChild(element);
		element = document.getElementById('gui_modal_root');
	}

	return ReactDOM.createPortal(
		<CSSTransition classNames="floating_layer" timeout={TRANSITION_DURATION} in={visible}>
			{(on) ? (
				<span className="gui_floating_layer_container is_ltr">
					<aside onMouseDown={close} class={classname}>
						<div class="contents" style={props?.contents_style || null}>
							{props.children}

							{(enable_close) && (
								<CloseButton onClick={close} />
							)}
						</div>
					</aside>
				</span>
			) : (
				<div />
			)}
		</CSSTransition>,
		element,
	);
}

export default FloatingLayer;